import { Component, Input } from '@angular/core';

import { CatService } from '../../services/cat/cat.service';

@Component({
	standalone: false,
	selector: 'loading-text-display',
	styleUrls: [ './loading-text-display.component.css' ],
	templateUrl: './loading-text-display.component.html'
})
export class LoadingTextDisplayComponent {
	constructor(public readonly catService: CatService) {}

	@Input()
	isLoading: boolean = false;
}
